import axios from 'axios';

import { getApiEndPoint } from '../../../helpers/apibase';
import { mapServerError } from '../../../services/utils/serverErrorMapper';

const baseURL = getApiEndPoint();

const whitelabelApi = axios.create({
  baseURL: `${baseURL}/api/v1.0`,
  withCredentials: true,
});

export interface AppGeneralConfigModel {
  PrivateSupportEmailAddress?: string;
  SmsRestaurantName?: string;
  appName?: string;
  bundleId?: string;
  [key: string]: unknown;
}

export const generalConfigQueryKey = 'whitelabelGeneralConfig';

export const getGeneralConfig = async (appId: string): Promise<AppGeneralConfigModel> => {
  try {
    const response = await whitelabelApi.get(`/whitelabelconfig/${appId}/general`);
    return response.data.Data;
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

export const updateGeneralConfig = async (
  appId: string,
  config: AppGeneralConfigModel
): Promise<void> => {
  try {
    await whitelabelApi.post(`/whitelabelconfig/${appId}/general`, config);
  } catch (error) {
    const e = await mapServerError(error);
    throw e;
  }
};

export const generalConfigService = {
  getGeneralConfig,
  updateGeneralConfig,
};
